import React from "react";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import NoteTab from "../../Note/Notetab";
import DocumentsTab from "../../Document/DocumentTab";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import { useLocalTransportRuleDetailContext } from "contexts/LocalTransportRuleDetailContext";

const LocalTransportRuleDetailTab = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "note";
  const { ruleDetail } = useLocalTransportRuleDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    { source: "LocalTransportRule", sourceRef: ruleDetail?._id },
    { skip: !ruleDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "LocalTransportRule", sourceRef: ruleDetail?._id },
    { skip: !ruleDetail?._id }
  );

  const tabs = [
    { label: "Note", value: "note", badgeCount: notes?.length || 0 },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />
      {ruleDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="LocalTransportRule" sourceRef={ruleDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="LocalTransportRule"
              sourceRef={ruleDetail._id}
            />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default LocalTransportRuleDetailTab;
